<template>
  <div class="wrapper">
    <p class="pub-title">联系我们</p>
    <p class="pub-sub-title">contact us</p>
    <div class="box">
      <div>
        <p>
          <img src="../assets/mail.png" alt="" /><img
            src="../assets/mail-check.png"
            alt=""
          />
        </p>
        <p>
          <span class="title">邮箱</span>
          <br />
          <span class="desc">{{ config.email }}</span>
        </p>
      </div>
      <div>
        <p>
          <img src="../assets/tel.png" alt="" /><img
            src="../assets/tel-check.png"
            alt=""
          />
        </p>
        <p>
          <span class="title">微信</span>
          <br />
          <span class="desc">{{ config.wechat }}</span>
        </p>
      </div>
      <div>
        <p>
          <img src="../assets/phone.png" alt="" /><img
            src="../assets/phone-check.png"
            alt=""
          />
        </p>
        <p>
          <span class="title">手机</span>
          <br />
          <span class="desc">{{ config.tel }}</span>
        </p>
      </div>
      <div>
        <p>
          <img src="../assets/address.png" alt="" /><img
            src="../assets/address-check.png"
            alt=""
          />
        </p>
        <p>
          <span class="title">总部地址</span>
          <br />
          <span class="desc">{{ config.address }}</span>
        </p>
      </div>
    </div>
    <baidu-map
      :center="config"
      :zoom="15"
      id="map"
      class="baidu-map-view"
      ak="YhllasINn7Y0zyEGLyXmBGx47AVBwAxM"
      :marker="config"
      scroll-wheel-zoom
    >
      <bm-marker key="marker.code" :position="config"> </bm-marker>
    </baidu-map>
  </div>
</template>

<script>
import {
  BaiduMap,
  BmScale,
  BmGeolocation,
  BmNavigation,
  BmMarkerClusterer,
  BmMarker,
  BmInfoWindow,
  BmTransit,
  BmOverlay,
} from 'vue-baidu-map'
import { config } from '../utils/api'
export default {
  components: {
    BaiduMap,
    BmScale,
    BmGeolocation,
    BmNavigation,
    BmMarkerClusterer,
    BmMarker,
    BmInfoWindow,
    BmTransit,
    BmOverlay,
  },
  data() {
    return {
      center: {
        lng: 109.45744048529967,
        lat: 36.49771311230842,
      },
      config: {},
    }
  },
  mounted() {
    config((r) => {
      this.config = r.data
    })
  },
}
</script>

<style lang="less" scoped >
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 0;
  .box {
    width: 100%;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;

    div:hover {
      background: #006C8F;
      box-shadow: 0px 4px 10px rgba(2, 178, 181, 0.2);
      img:last-child {
        display: inline-block !important;
      }
      img:first-child {
        display: none;
      }
      p {
        .title,
        .desc {
          color: white;
        }
      }
    }
    div {
      padding: 20px;
      width: 270px;
      height: 166px;
      background: #f5f5f5;
      transition: all 0.15s linear;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      p {
        text-align: right;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        transition: all 0.15s linear;
        width: 100%;
        .title {
          font-size: 22px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #1a1a1a;
          transition: all 0.15s linear;
        }
        .desc {
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 18px;
          color: #4d4d4d;
          margin-top: 8px;
        }
      }
      p:first-child {
        text-align: left;
        img {
          height: 26px;
        }
        img:last-child {
          display: none;
        }
      }
    }
  }
}
#map {
  width: 100%;
  height: 400px;
  margin-top: 40px;
}
@media (max-width: 767px) {
  .wrapper {
    padding: 1.56rem 0.34rem;
    box-sizing: border-box;
    .box {
      margin-top: 0.34rem;
      flex-wrap: wrap;
      div {
        width: 3.24rem;
        height: 2rem;
        padding: 0.24rem;
        margin-bottom: 0.34rem;
        p:first-child {
          img {
            height: 0.28rem;
          }
        }
        p {
          font-size: 0;
          display: block;
          height: unset;
          .title {
            font-size: 0.28rem;
          }
          .desc {
            font-size: 0.2rem;
          }
        }
      }
    }
  }
  #map {
    height: 4.2rem;
  }
}
</style>